import { render, staticRenderFns } from "./NewModuleModal.vue?vue&type=template&id=1a26e386&"
import script from "./NewModuleModal.vue?vue&type=script&lang=js&"
export * from "./NewModuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports